import { useDispatch, useSelector } from 'react-redux';
import { Button, CheckCircle, Colors, EnProgresoSVG, SuccessfulProcessSVG } from 'common-ui-components';
import { selectConfig, selectPromoter } from '../../redux/selectors';
import { navigateTo } from '../../redux/Slice/navigationSlice';
import ShareIcons from '../../components/ShareIcons';
import { useState } from 'react';
import CustomBanner from '../../components/CustomBanner';

const EndProcess = () => {
  const [hasShared, setHasShared] = useState(false);
  const {
    language: {
      promoter: { finalScreen: text },
    },
  } = useSelector(selectConfig);
  const dispatch = useDispatch();
  const {
    data: { idu },
  } = useSelector(selectPromoter);
  const referralLink = `${text.url}?idu=${idu}`;
  const shareText = text.shareText.replace('{link}', referralLink);
  const mailSubject = text.mailSubject;

  return (
    <section className='section promoter-final'>
      <div className='promoter-final-background'></div>
      <div className='promoter-final-container'>
        {
          hasShared ?
            <SuccessfulProcessSVG
              transparent
              style={{ width: '200px' }}
            />
            :
            <EnProgresoSVG
              transparent
              style={{ width: '200px' }}
            />
        }
      </div>
      <div className='promoter-final-details'>
        <p className='promoter-final-subtitle'>{text.subtitle}</p>
        <p className='promoter-final-paragraph'>{text.paragraph}</p>
        <ShareIcons
          bodyText={shareText}
          subjectText={mailSubject}
          setHasShared={setHasShared}
          copyToastText={text.copyToastText}
        />
        <div className='promoter-final-actions'>
          <Button
            className='submit-button-error'
            data-testid='promoter-restart-button'
            onClick={() => dispatch(navigateTo('Promoter'))}
            disabled={!hasShared}
          >
            {text.secondaryButton}
          </Button>
          <CustomBanner color={Colors.azulBackground} text={text.reminder} />
        </div>
      </div>
    </section>
  );
};

export default EndProcess;
